import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/single',
    name: 'single',
    component: () => import('../views/SingleView.vue')
  },
  {
    path: '/double',
    name: 'double',
    component: () => import('../views/DoubleView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
